import { render } from "./MultisidebarItem.vue?vue&type=template&id=3257db22&ts=true"
import script from "./MultisidebarItem.vue?vue&type=script&lang=ts"
export * from "./MultisidebarItem.vue?vue&type=script&lang=ts"

import "./MultisidebarItem.vue?vue&type=style&index=0&id=3257db22&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__